var map = {
	"./1.jpg": 6494,
	"./2.jpg": 9577,
	"./3.jpg": 1532,
	"./4.jpg": 2727,
	"./5.jpg": 8890,
	"./6.jpg": 1493,
	"./life1.jpg": 7700,
	"./life2.jpg": 6144
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2945;